import { render, staticRenderFns } from "./PageUnitPref.vue?vue&type=template&id=50e7b2f4"
import script from "./PageUnitPref.vue?vue&type=script&lang=js"
export * from "./PageUnitPref.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports